import { Box, Chip, Tooltip } from "@mui/material";
import { createSearchParams, useNavigate } from "react-router-dom";
import { PROVIDER_PATHS } from "../../../../constants/paths";
import { PATIENT_INQUIRY_STATUS_PARAM } from "../../../../pages/app/provider/collabration/patient-inquiries/patient-inquiry-constants";
import { useGetPatientInquiryStatusCounts } from "../../../../queries/collaboration/patient-inquiry/use-get-patient-inquiry-status-counts";
import { GetPatientInquiryListStatusEnum } from "../../../../services";
import { DEFAULT_TEXT_COLOR, getXtenantId } from "../../../../utils/utils";
import Text from "../../../Text";

/**
 * "Patient Inquiries" shortcut with the practice's pending-inquiry count,
 * shown beside the day/week/month dropdown in the scheduling toolbar.
 *
 * Clicking through opens the list with the Pending status filter already
 * applied, so what lands on screen is the count that was just clicked.
 *
 * The badge is dropped when there is nothing pending — and when the count
 * cannot be retrieved, so the toolbar degrades to a plain link instead of
 * showing an error or a stale number.
 */
const PendingInquiriesCount = () => {
  const navigate = useNavigate();
  const xTENANTID = getXtenantId();

  const { pendingCount, isError } = useGetPatientInquiryStatusCounts({
    xTENANTID,
  });

  const showCount = !isError && pendingCount > 0;

  return (
    <Tooltip title="View patient inquiries">
      {/* Box, not Flex — Tooltip needs a child that forwards its ref. */}
      <Box
        onClick={() =>
          navigate({
            pathname: PROVIDER_PATHS.PATIENT_INQUIRIES,
            search: createSearchParams({
              [PATIENT_INQUIRY_STATUS_PARAM]:
                GetPatientInquiryListStatusEnum.Pending,
            }).toString(),
          })
        }
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          cursor: "pointer",
          whiteSpace: "nowrap",
          flexShrink: 0,
        }}
      >
        <Text c={DEFAULT_TEXT_COLOR} fontWeight={500}>
          Patient Inquiries
        </Text>
        {showCount && (
          <Chip
            color="error"
            variant="filled"
            size="small"
            label={pendingCount}
            sx={{
              fontSize: "10px",
              height: "18px",
              padding: 0,
              "& .MuiChip-label": { padding: "0 6px" },
            }}
          />
        )}
      </Box>
    </Tooltip>
  );
};

export default PendingInquiriesCount;
